// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"137":"a7763b5e","453":"80c93225","656":"ba2eb142","725":"120229f4","750":"f2c5da33","896":"c03cda6e","974":"f7339528"}[chunkId] + ".chunk.js";
};